import React from 'react';

export default function ChartMessage({ title, description, reminder }) {
  return (
    <div style={{padding: '23% 0 0', maxWidth: 312, margin: '0 auto'}}>
      <p style={{color: '#10587f', marginBottom: 16, textAlign: 'center', fontSize: 24, fontWeight: 'bold'}}>{title}</p>
      <p style={{color: '#484848', marginBottom: 16, textAlign: 'center'}}>{description}</p>
      <p style={{color: '#484848', fontWeight: 'bold', marginBottom: 16, textAlign: 'center', fontSize: 14}}>{reminder}</p>
    </div>
  );
}
